function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef } from "react";
import { useCalendarCell } from "react-aria";
import { getLocalTimeZone, isSameMonth, isToday, isWeekend, today } from "@internationalized/date";
import { Box } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
import { themeGet } from "sprout-ui-theme";
import { StarBorder } from "sprout-ui-icons";
import { Button } from "../Button";
const CalendarCellButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;

  color: ${({ $isWeekend  })=>$isWeekend ? themeGet("colors.blue.40") : themeGet("colors.white.100")};

  [aria-disabled="true"] & {
    cursor: not-allowed;
    color: ${themeGet("colors.white.60")};
  }

  [aria-selected="true"]:not([aria-disabled="true"]) & {
    border: 3px solid ${themeGet("colors.yellow.200")};
    border-radius: 4px;
  }

  ${({ $showSelectedError  })=>$showSelectedError && css`
      border: 3px solid #ff1744;
      border-radius: 4px;
    `}

  :not([aria-disabled="true"]) {
    &:hover {
      border-radius: 4px;
      background: ${themeGet("colors.yellow.200")};
      color: ${themeGet("colors.blue.500")};
    }
  }

  ${({ $hidden  })=>$hidden && css`
      visibility: hidden;
    `}
`;
const CalendarCell = (props)=>{
    const { state , date , locale , scheduler , currentMonth  } = props;
    const ref = useRef(null);
    const { cellProps , formattedDate , buttonProps , isSelected  } = useCalendarCell({
        date
    }, state, ref);
    const isLessThanToday = useMemo(()=>{
        return date.compare(today(getLocalTimeZone())) < 0;
    }, [
        date
    ]);
    return /*#__PURE__*/ _jsx(Box, _objectSpread({
        as: "td",
        textAlign: "center"
    }, cellProps, {
        children: /*#__PURE__*/ _jsx(CalendarCellButton, _objectSpread({}, buttonProps, {
            $isWeekend: isWeekend(date, locale),
            $showSelectedError: isLessThanToday && isSelected,
            $hidden: currentMonth ? !isSameMonth(date, currentMonth) : false,
            children: scheduler && isToday(date, getLocalTimeZone()) ? /*#__PURE__*/ _jsx(StarBorder, {}) : formattedDate
        }))
    }));
};
export default CalendarCell;
